var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestAction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2,26.3l-1.8-1.4C38.6,20,33,29.7,38.7,33.5l5.8,3.4c7.5,4.4,2.4,14.5-6.2,10.8l-3.8-2M42,54V48.5M42,18v5.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.28,
    y1: 56.21,
    x2: 66.28,
    y2: 20.79
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.28,
    y1: 56.21,
    x2: 59.28,
    y2: 25.79
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "53.5 56.21 71.78 56.21 71.78 60.21 76.78 60.21 76.78 66.21 7.22 66.21 7.22 60.21 12.22 60.21 12.22 56.21 30.5 56.21"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.72,
    y1: 20.79,
    x2: 17.72,
    y2: 56.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.72,
    y1: 25.79,
    x2: 24.72,
    y2: 56.21
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "30.5 20.15 7.72 20.15 7.72 15.29 42 4.79 76.28 15.29 76.28 20.15 53.5 20.15"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestAction);
export default __webpack_public_path__ + "static/media/invest-action.ace93e4c.svg";
export { ForwardRef as ReactComponent };